import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import partnershipBanner from "../../../assets/images/partnerships/partnership-header.webp";
import partnershipData from "../../../helpers/partnerships.json";
import CommonMeta from "../../comman/CommonMeta";
import Footer from "../../comman/footer";
import Header from "../../comman/header";
import "./partnerships.scss";

export const partnershipArticle = {
  ...partnershipData,
  image: require(`../../../assets/images/partnerships/${partnershipData.image}`),
  shortContent: partnershipData.sections[0].paragraphs[0],
};

export const PartnershipContent = () => (
  <div className="partnership-copy">
    {partnershipData.sections.map((section) => (
      <section key={section.heading}>
        <h3>{section.heading}</h3>
        {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        {section.link && (
          <p>
            <a href={section.link.url} target="_blank" rel="noopener noreferrer">
              {section.link.label}
            </a>
          </p>
        )}
        {section.list && (
          <ul>{section.list.map((item) => <li key={item}>{item}</li>)}</ul>
        )}
      </section>
    ))}
    <p>
      <a
        href={(process.env.PUBLIC_URL || "") + partnershipData.pressRelease.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {partnershipData.pressRelease.label}
      </a>
    </p>
  </div>
);

export const PartnershipsSection = ({ home = false }) => {
  const { t } = useTranslation();
  const title = t(partnershipData.label);
  const partnership = partnershipArticle;

  return (
    <div
      id={home ? "Partnerships" : undefined}
      className={`partnerships-page${home ? " partnerships-home-section" : ""}`}
    >
      <section className="partnerships-content" aria-label={title}>
        <Container>
          {home && (
            <div className="heading-text">
              <h4>{title}</h4>
            </div>
          )}
          <Row className="news-main-wrapper partnerships-grid">
            <article className="box-wrapper">
              <div className="news-event-box">
                <div className="news-event-image">
                  <img
                    loading="lazy"
                    src={partnership.image}
                    className="img-fluid"
                    alt={partnership.title}
                  />
                  <div className="card-body">
                    <div className="details">
                      <h2 className="partnership-card-title">{t(partnership.title)}</h2>
                      <p className="partnership-card-intro">
                        {t(partnership.shortContent)}
                      </p>
                    </div>
                    <div className="read-more-link">
                      <Link
                        to={`/partnerships/${partnership.slug}`}
                        className="partnership-read-more"
                        aria-label={`${t("more")}: ${t(partnership.title)}`}
                      >
                        {t("more")}
                        <i className="icon icon-next" aria-hidden="true"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </Row>
        </Container>
      </section>
    </div>
  );
};

const Partnerships = () => {
  const { t } = useTranslation();
  const title = t(partnershipData.label);

  return (
    <>
      <CommonMeta
        title={title}
        description={partnershipArticle.shortContent}
        keywords={partnershipData.keywords}
        name="Poddar Pigments Limited"
        type="website"
      />
      <Header />
      <main className="partnerships-page">
        <div
          className="top-banner-image about-us-bg"
          style={{ backgroundImage: `url(${partnershipBanner})` }}
        >
          <Container>
            <Row>
              <Col xs={12}>
                <div className="top-heading-text">
                  <h1>{partnershipData.bannerTitle}</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="breadcrumb-wrapper">
          <Container>
            <Row>
              <Col xs={12}>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">{t("Home")}</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {title}
                    </li>
                  </ol>
                </nav>
              </Col>
            </Row>
          </Container>
        </div>
        <PartnershipsSection />
      </main>
      <Footer />
    </>
  );
};

export default Partnerships;
